import React, { useState, useEffect, useMemo } from 'react'
import './styles.css'
import { Button, Col, Divider, Form, Input, Popconfirm, Row, Select, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { meioComunicacaoService } from '../../services/Meio-Comunicacao-Service/Meio-Comunicacao-Service';

interface inputSelectMeioComunicacaoProp {
    meioComunicacaoID?: number
    ehEdicao?: boolean;
    visibleModal?: any,
}

const InputSelectMeioComunicacao: React.FC<inputSelectMeioComunicacaoProp> = (prop) => {

    const [formMeioComunicacao] = Form.useForm();
    const [meioComunicacao, setMeioComunicacao] = useState<any[]>();
    const [visibilityInput, setVisibilityInput] = useState<boolean>(false);
    const [ehGEstor, setEhGestor] = useState<boolean>(false);

    useEffect(() => {
        meioComunicacaoService.getAll().then((resp) => {
            if (resp.status == 200) {
                setMeioComunicacao(resp.data.filter((i: any) => i.ativo == true))
            }
        })
        validarEhGestor()
    }, [])

    useMemo(() => {
        setVisibilityInput(false)
        formMeioComunicacao.resetFields()
    }, [prop.visibleModal])

    const validarEhGestor = () => {
        var grupoLogado = parseInt(sessionStorage.getItem('grupoID') || "")
        if (grupoLogado == 1330 || grupoLogado == 1334 || grupoLogado == 1336)
            setEhGestor(true)
        else
            setEhGestor(false)
    }


    function addMeioComunicacao() {

        setVisibilityInput(true)
        let meioComunicacao = {
            descricao: formMeioComunicacao.getFieldValue("descricao")
        }

        meioComunicacaoService.post(meioComunicacao)
            .then((resp) => {
                message.success("Meio de comunicação adicionado com sucesso")
                formMeioComunicacao.resetFields()
                setVisibilityInput(false)
            })
            .finally(() => {
                meioComunicacaoService.getAll().then((resp) => {
                    if (resp.status == 200) {
                        setMeioComunicacao(resp.data.filter((i: any) => i.ativo == true))
                    }
                })
            })
            .catch((err) => {
                message.error(err.response.data.error[0] || "Erro inesperado")
                formMeioComunicacao.resetFields()
                setVisibilityInput(false)
            })
    }

    return (
        <Form.Item name="meioComunicacaoID" label="Meio de Comunicação" rules={[{ required: prop.meioComunicacaoID == undefined && !prop.ehEdicao ? true : false, message: "Meio de Comunicação é obrigatório" }]}>
            <Select showSearch
                listHeight={160}
                filterOption={(input, option) => {
                    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                }
                filterSort={(optionA, optionB) => {
                    return (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                }
                placeholder="Selecione o meio de comunicação" dropdownRender={menu => (
                    <>
                        {menu}
                        {
                            ehGEstor ?
                                <>
                                    < Divider style={{ margin: '8px 0' }} />
                                    <Form form={formMeioComunicacao} style={{ marginBottom: '-15px' }} className='descricaoAreaCadastro'>
                                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            {visibilityInput ?
                                                <Col span={16}>
                                                    <Form.Item name="descricao" >
                                                        <Input
                                                            placeholder="Digite a descrição"
                                                            id='descricaoMeioComunicacao'
                                                            type='text'
                                                            maxLength={15}
                                                        />
                                                    </Form.Item>
                                                </Col> : null}
                                            <Col span={8}>
                                                <Form.Item>
                                                    {visibilityInput ?
                                                        <Popconfirm placement='bottom' title="Deseja realmente adicionar um novo Meio de Comunicação?" onCancel={() => { setVisibilityInput(false); formMeioComunicacao.resetFields() }} onConfirm={addMeioComunicacao} >
                                                            <Button type="primary" htmlType='button' icon={<PlusOutlined />} >
                                                                Salvar
                                                            </Button>
                                                        </Popconfirm> :
                                                        <Button type="primary" onClick={() => { if (!visibilityInput) { setVisibilityInput(true) } }} icon={<PlusOutlined />} >
                                                            Adicionar
                                                        </Button>}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </>
                                : null
                        }

                    </>)}
                options={meioComunicacao?.map((m) => ({ label: m?.descricao, value: m?.meioComunicacaoID }))}>
            </Select >
        </Form.Item>
    )
}

export default InputSelectMeioComunicacao